module.exports = {
  'en-US': require('./en-US.json'),
  'zh-CN': require('./zh-CN.json')
};